// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyATmP27k_0eMiHCrxCE8vojGi5BgD3j0hw",
    authDomain: "organicshop-2a12c.firebaseapp.com",
    databaseURL: "https://organicshop-2a12c.firebaseio.com",
    projectId: "organicshop-2a12c",
    storageBucket: "organicshop-2a12c.appspot.com",
    messagingSenderId: "1078222206637"
  },
};



// WEBPACK FOOTER //
// G:/MyProjects/Angular/oshop/src/environments/environment.ts